export const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
        return text.slice(0, maxLength) + '...';
    }
    return text;
}
export const isProductUnavailable = (productsByBrand, item) => {
    const pendingStock = item.product_variants.allowed_inventory_quantity;
    const inventoryTracked = item.product_variants.inventory_management;

    if (item?.products?.store_products?.length === 0) return true;
    if (item?.products?.user.invitees?.[0]?.invite_status === 'accepted' ||
        item?.products?.user.inviters?.[0]?.invite_status === 'accepted') {
        return false;
    }

    if (!item?.products?.user.invitees?.length && !item?.products?.user.inviters?.length) {
        return true;
    }
    if (productsByBrand?.brand_user?.access_token?.is_active !== true) return true;

    if (item?.products?.product_status?.status !== 'active') return true;

    if (item?.product_variants?.status !== '1') return true;


    if (!inventoryTracked) return false;

    if (pendingStock === 0) return true;

    if (item.product_variants.status !== '1') return true;
    if (!item.products || item.products.status !== 1) return true;
    if (!productsByBrand?.brand_user?.access_token?.is_active) return true;
    if (item?.product_variants?.is_deleted) return true;

    return false;
};
export const checkCheckoutEnabled = (cartItems) => {
    let checkDisabled = false;
    cartItems?.map((cart, i) => {
      cart.cart_items.map((item, i) => {
        if (isProductUnavailable(cart, item)) {
          checkDisabled = true;
        }
      })
    })

    return checkDisabled
  }
export const detectMob=()=> {
  const isMobile = /iPhone|Android/i.test(navigator.userAgent);
    return isMobile;
  }